export default __webpack_public_path__ + "images/gray-dot.png";